<template>
  <div v-if="props.visible" class="address-form">
    <h3>{{ t('checkout.addNewAddress') }}</h3>
    <form @submit.prevent="submitAddress">
      <v-row>
        <v-col>
          <label>{{ t('checkout.firstName') }}</label>
          <input v-model="address.firstName" required />
        </v-col>
        <v-col>
          <label>{{ t('checkout.lastName') }}</label>
          <input v-model="address.lastName" required />
        </v-col>
      </v-row>
      <div>
        <label>{{ t('checkout.phone_number') }}</label>
        <input v-model="address.phoneNumber" required />
      </div>
      <div>
        <label>{{ t('checkout.address') }}</label>
        <input v-model="address.street" required />
      </div>
      <div>
        <label>{{ t('checkout.country') }}</label>
        <v-select
         v-model="address.country" 
         @update:modelValue="updateRegions" 
         :items="countries"
         :item-title="country => country.countrySlug + ' ' + t(`countries['${country.countryName}']`)"
         :item-value="country => country.countryName"
         outlined
         required
         ></v-select>
      </div>
      <v-row>
        <v-col>
          <label>{{ t('checkout.city') }}</label>
          <input v-model="address.city" required />
        </v-col>
        <v-col>
          <div>
            <label>{{ t('checkout.state') }}</label>
            <v-select 
            v-model="address.region" 
            :items="regions"
            :item-title="region => t(`regions['${region.name}']`)"
            :item-value="region => region.name"
            outlined
            required
            ></v-select>
        </div>
        </v-col>
      </v-row>
      <div>
        <label>{{ t('checkout.postal_code') }}</label>
        <input v-model="address.postalCode" required />
      </div>
      <button type="submit">{{ t('checkout.saveAddress') }}</button>
    </form>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { allCountries } from 'country-region-data/dist/data.js';

const { t } = useI18n();
const props = defineProps(['visible', 'address']);
const emit = defineEmits(['addressSaved']);

const address = ref({
  fullName: '',
  firstName: '',
  lastName: '',
  street: '',
  region: '',
  city: '',
  phoneNumber: '',
  postalCode: '',
  country: '',
  countrySlug: '',
  regionSlug: '',
});

const countries = ref(allCountries.map(([countryName, countrySlug, regions]) => ({
  countryName,
  countrySlug,
  regions: regions.map(([regionName, regionSlug]) => ({
    name: regionName,
    slug: regionSlug
  }))
})));

if(props.address != null && props.address != ''){
    address.value = Object.assign({}, props.address);
    console.log(address.value, props.address, "address.value");
  }
const regions = ref([]);

console.log(props.address, address.value, "props.address");
watch(()=> address.value.fullName, (newFullName) => {
  if(newFullName != '' && newFullName != null){
    address.value.firstName = newFullName.split(' ')[0] ? newFullName.split(' ')[0] : '';
    address.value.lastName = newFullName.split(' ')[1] ? newFullName.split(' ')[1] : '';
  }
});
watch(()=> regions.value, (newRegions) => {
  console.log(newRegions, "newRegions");
});
watch(()=> address.value.firstName, (newFirstName) => {
  address.value.fullName = newFirstName + ' ' + address.value.lastName;
});
watch(()=> address.value.lastName, (newLastName) => {
  address.value.fullName = address.value.firstName + ' ' + newLastName;
});
watch(()=> props.address, (newAddress) => {
  address.value = Object.assign({}, newAddress);
  updateRegions();
});
watch(()=> address.value.country, (newCountry) => {
  const country1 = countries.value.find((country) => country.countryName === newCountry );
  console.log(country1, "country b9soit32");
  if(country1){
    console.log(country1, "countrySlug");
    address.value.countrySlug = country1.countrySlug;
  } else {
    address.value.countrySlug = '';
  }
});
watch(()=> address.value.region, (newRegion) => {
  console.log(newRegion, "regionSlug");
  const region1 = regions.value.find(region => region.name === newRegion);
  if(region1){
    console.log(region1, "regionSlug");
    address.value.regionSlug = region1.slug;
  } else {
    address.value.regionSlug = '';
  }
});
onMounted(() => {
  if(address.value.country != ''){
    updateRegions();
  }
});
// const updateCity = () => {
//   console.log(address.value.region, address.value, "region");
// };
const updateRegions = () => {
  const selectedCountry = countries.value.find(country => country.countryName === address.value.country);
  regions.value = selectedCountry ? selectedCountry.regions : [];
  console.log(regions.value, "regions.value");
};

const submitAddress = () => {
  console.log(address.value, 'address.value');
  emit('addressSaved', { ...address.value });
  // Reset form
  address.value = {
    fullName: '',
    firstName: '',
    lastName: '',
    street: '',
    region: '',
    city: '',
    phoneNumber: '',
    postalCode: '',
    country: '',
    countryName: '',
    countrySlug: '',
    regionSlug: '',
  };
};
</script>

<style scoped>
.address-form {
  border: 1px solid #ddd;
  padding: 20px;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 5px;
}

.address-form div {
  margin-bottom: 15px;
}

.address-form label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #2c3e50;
}

.address-form input,
.address-form select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
}

.address-form input::placeholder {
  color: #aaa;
}
@media (max-width: 600px) {
    .address-form select {
      width: 100%;
    }
  }
button {
  width: 100%;
  padding: 10px;
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

button:hover {
  background-color: #e0e0e0;
}
</style>
